import React from 'react';
import { Row, Col, Subtitle } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<div>
                <Row>
                    <Col>
                        <Subtitle>Subtitle one</Subtitle>
                        <Subtitle className="mt-5">Subtitle two</Subtitle>
                    </Col>
                </Row>
            </div>);
    }
}
